module.exports = __webpack_public_path__ + "static/media/drvspace_7.b5e6c664.ico";